import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Anleggsprojeksjonsflate from './Anleggsprojeksjonsflate.jsx'
import AnleggsprojeksjonsflateIcon from '../../../images/Annleggsprojeksjonsflate.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'


class AnleggsprojeksjonsflateList extends Component {
    state = {
        anleggsprojeksjonsflater: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getAnleggsprojeksjonsflater = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/anleggsprojeksjonsflate`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                anleggsprojeksjonsflater: [...this.state.anleggsprojeksjonsflater, ...data.anleggsprojeksjonsflater],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
    }

    toggleAnleggsprojeksjonsflater = () => {
        if (this.props.antall == 0) return

        if (this.state.anleggsprojeksjonsflater.length == 0) {
            this.getAnleggsprojeksjonsflater()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var antallAnleggsprojeksjonsflater = this.state.continuationToken ? `${this.state.anleggsprojeksjonsflater.length}/${this.props.antall}` : this.props.antall
        return (
            <li>
                <div className="section-header" onClick={this.toggleAnleggsprojeksjonsflater}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={AnleggsprojeksjonsflateIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('anleggsprojeksjonsflater')} ({antallAnleggsprojeksjonsflater})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.anleggsprojeksjonsflater.length > 0 ? "" : "collapsed"}>
                    <ul>
                        {this.state.anleggsprojeksjonsflater.map((a, index) => { return (<Anleggsprojeksjonsflate key={a.anleggsprojeksjonsflateId} anleggsprojeksjonsflate={a} antall={this.props.antall} isLast={index==this.state.anleggsprojeksjonsflater.length-1} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getAnleggsprojeksjonsflater}>
                                <span>{t('hent.anleggsprojeksjonsflater')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(AnleggsprojeksjonsflateList)